enum Authorization {
    AUTHN = 'adultswim.authn',
    CREATE_PROFILE = 'adultswim.createprofile',
    LEGAL_DOCS = 'adultswim.legaldocs',
    UPDATE_PASSWORD = 'adultswim.updatepassword',
    REGISTERED = 'adultswim.registered',
    VERIFIED = 'adultswim.verified',
}

export default Authorization;
